import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap/";
import "./PhotographyPortfolio.css";
import Colorful from "../images/Photo_gallery/Colorful.jpg";
import Storm from "../images/Photo_gallery/Calm Before the Storm.jpg";
import Flare from "../images/Photo_gallery/Flare.jpg";
import Sunny_trail from "../images/Photo_gallery/sunny_trail.jpg";
import Waterfall from "../images/Photo_gallery/waterfall2.JPG";
import Beach from "../images/Photo_gallery/Beach2.jpg";
import Serenity from "../images/Photo_gallery/Ocean2.jpg";
import Hike from "../images/Photo_gallery/Hike.jpg";
import Tofino from "../images/Photo_gallery/Tofino.png";
import Geneva from "../images/Photo_gallery/Geneve.jpg";
import Capri from "../images/Photo_gallery/Capri.jpeg";
import { useInView } from "react-intersection-observer";

function PhotographyPortfolio() {
  const { ref: photographyRef, inView: photographyVisible } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const carouselItems = [
    { src: Flare, alt: "Flare", label: "Flare" },
    { src: Tofino, alt: "Tofino", label: "Edge of the World" },
    { src: Geneva, alt: "Geneva", label: "Geneva" },
    { src: Capri, alt: "Capri", label: "Posterized" },
    { src: Beach, alt: "Bliss", label: "Bliss" },
    { src: Serenity, alt: "Serenity", label: "Serenity" },
    { src: Storm, alt: "Storm", label: "Calm Before the Storm" },
    { src: Sunny_trail, alt: "Sunny Trail", label: "Sunny Trail" },
    { src: Waterfall, alt: "Waterfall", label: "Smooth Falls" },
    { src: Colorful, alt: "Colorful", label: "Colorful" },
    { src: Hike, alt: "Hike", label: "Hike" },
  ];

  return (
    <Container
      fluid
      className="photographySection py-6"
      id="photographyPortfolio"
      ref={photographyRef}
    >
      <Container className={`${photographyVisible ? "fade-in-up" : "opacity-0"}`}>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Photography Gallery</h2>
          <div className="titleHr" />
        </div>

        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={9}>
            <div className="glass-card carouselFrame p-3 p-md-4">
              <Carousel className="photoCarousel" pause="hover" indicators={true}>
                {carouselItems.map((item, index) => (
                  <Carousel.Item key={index}>
                    <div className="photoSlideWrapper">
                      <img
                        className="d-block photoSlideImg"
                        src={item.src}
                        alt={item.alt}
                        loading="lazy"
                      />
                    </div>
                    {item.label}
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </Container >
  );
}

export default PhotographyPortfolio;
